export {IconTray} from './icon-tray'